(function() {

	var DatosCotizador = {
			stay: {
				checkIn: '',
				checkOut: ''
			},
			occupancies: [],
			destination: {
			},
			reset: function() {
				this.occupancies = [];
				this.destination = {};
				this.stay = {
					checkIn: '',
					checkOut: ''
				};
			}
		};

	angular
		.module('ngmvac')
		.value('DatosCotizador', DatosCotizador);

})();